import React from 'react';
import { useParams } from 'react-router-dom';
import StorePaymentsWrapper from './StorePaymentsWrapper';
import DashboardSidebar from '../DashboardSidebar';

const TransactionsPage: React.FC = () => {
  const { store_id } = useParams<{ store_id: string }>();
  const userStr = localStorage.getItem("user");
  const userObj = userStr ? JSON.parse(userStr) : null;
  const targetStoreId = store_id ? Number(store_id) : userObj?.store_id;
  
  return (
    <>
    <div className="payouts-page-wrapper">
      {userObj?.current_role !== 1 && <DashboardSidebar />}
      <div className="payouts-content">
        <div className="div-block-28">
          <div className="payouts-toolbar">
            <span className="payment-details-title"></span>
          </div>
          
          <div className="payouts-table-wrapper">
            {targetStoreId ? (
              <StorePaymentsWrapper storeId={targetStoreId} />
            ) : (
              <p className="payouts-invalid-store">Invalid store ID or you are not associated with a store.</p>
            )}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default TransactionsPage;
